import * as React from 'react';
import type { TPAComponentProps } from '../../types';

export interface GridProps extends TPAComponentProps {
  children?: React.ReactNode[];
  showRowDivider: boolean;
  uniformRowHeight: boolean;
  maxColumns?: number;
  minColumnWidth?: number;
  maxColumnWidth?: number;
  width?: number;
  rowGap?: number;
  columnGap?: number;
  dividerWidth?: string | number;
  /** Passing id to the container
   *  to apply the grid styles
   *  important that the ID is unique
   *  pass it when component is rendered in SSR
   */
  id?: string;
}

export interface GridDefaultProps {
  children: React.ReactNode[];
  showRowDivider: boolean;
  uniformRowHeight: boolean;
  maxColumns: number;
  width: number;
  minColumnWidth: number;
  dividerWidth: string;
}

export enum GridDataHooks {
  container = 'Grid-container',
  item = 'Grid-item',
}

export enum GridDataKeys {
  itemsPerRow = 'data-items-per-row',
  itemMaxWidth = 'data-item-max-width',
  dividerWidth = 'data-divider-width',
  rowGap = 'data-row-gap',
  columnGap = 'data-column-gap',
  rowSpan = 'data-row-span',
  columnSpan = 'data-column-span',
  maxColumnWidth = 'data-max-column-width',
  minColumnWidth = 'data-min-column-width',
}

export interface GridItemProps {
  children?: React.ReactNode | React.ReactNode[];
  colSpan?: number;
  rowSpan?: number;
}

export interface GridItemDefaultProps {
  colSpan: number;
  rowSpan: number;
}

export interface GridStyleProps {
  isFullWidth: boolean;
  maxColumns: number;
  minColumnWidth: number;
  maxColumnWidth: string;
  columnGap: number;
  rowGap: number;
  dividerWidth: string;
  cssStateDivider: string;
  gridId: string;
  gridTemplateColumns: string;
}
